module.exports = __webpack_public_path__ + "img/mawlr.87bb1790.svg";